import React, { useEffect, useState } from "react";
import "./personality.css";

// Posters
import diariosdemotocicleta from "../../movies/aventurera/diariosdemotocicleta.jpg";
import indianajones from "../../movies/aventurera/indianajones.jpg";
import jumanji from "../../movies/aventurera/jumanji.jpg";
import jurassicpark from "../../movies/aventurera/jurassicpark.jpg";
import lawrenceofarabia from "../../movies/aventurera/lawrenceofarabia.jpg";
import thelastofthemohicans from "../../movies/aventurera/thelastofthemohicans.jpg";
import themummy from "../../movies/aventurera/themummy.jpg";
import thereturnoftheking from "../../movies/aventurera/thereturnoftheking.jpg";
import thesecretlifeofwaltermitty from "../../movies/aventurera/thesecretlifeofwaltermitty.jpg";
import thewizardofoz from "../../movies/aventurera/thewizardofoz.jpg";

// Data
const movies = [
  {
    title: "Diarios de motocicleta",
    image: diariosdemotocicleta,
    director: "Walter Salles",
    year: 2004,
    cast: "Gael García Bernal, Rodrigo de la Serna",
    synopsis:
      "Ernesto 'Che' Guevara emprende un viaje por Sudamérica que transforma su visión del mundo."
  },
  {
    title: "Indiana Jones and the Raiders of the Lost Ark",
    image: indianajones,
    director: "Steven Spielberg",
    year: 1981,
    cast: "Harrison Ford, Karen Allen",
    synopsis:
      "Indiana Jones busca recuperar el Arca de la Alianza antes que los nazis."
  },
  {
    title: "Jumanji",
    image: jumanji,
    director: "Joe Johnston",
    year: 1995,
    cast: "Robin Williams, Kirsten Dunst",
    synopsis:
      "Un juego mágico libera peligros de la jungla en el mundo real."
  },
  {
    title: "Jurassic Park",
    image: jurassicpark,
    director: "Steven Spielberg",
    year: 1993,
    cast: "Sam Neill, Laura Dern, Jeff Goldblum",
    synopsis:
      "Un parque de dinosaurios clonados se vuelve un caos cuando fallan las medidas de seguridad."
  },
  {
    title: "Lawrence of Arabia",
    image: lawrenceofarabia,
    director: "David Lean",
    year: 1962,
    cast: "Peter O'Toole, Alec Guinness",
    synopsis:
      "La historia épica del militar y explorador T.E. Lawrence en la Primera Guerra Mundial."
  },
  {
    title: "The Last of the Mohicans",
    image: thelastofthemohicans,
    director: "Michael Mann",
    year: 1992,
    cast: "Daniel Day-Lewis, Madeleine Stowe",
    synopsis:
      "Amor y guerra en la frontera americana durante los conflictos coloniales."
  },
  {
    title: "The Mummy",
    image: themummy,
    director: "Stephen Sommers",
    year: 1999,
    cast: "Brendan Fraser, Rachel Weisz",
    synopsis:
      "Una momia antigua despierta y desata el caos en el Egipto moderno."
  },
  {
    title: "The Return of the King",
    image: thereturnoftheking,
    director: "Peter Jackson",
    year: 2003,
    cast: "Elijah Wood, Viggo Mortensen",
    synopsis:
      "El épico desenlace de la batalla por la Tierra Media."
  },
  {
    title: "The Secret Life of Walter Mitty",
    image: thesecretlifeofwaltermitty,
    director: "Ben Stiller",
    year: 2013,
    cast: "Ben Stiller, Kristen Wiig",
    synopsis:
      "Un hombre común comienza un viaje extraordinario lleno de aventura."
  },
  {
    title: "The Wizard of Oz",
    image: thewizardofoz,
    director: "Victor Fleming",
    year: 1939,
    cast: "Judy Garland, Ray Bolger",
    synopsis:
      "Dorothy viaja al mundo mágico de Oz y busca la forma de volver a casa."
  }
];

// ⭐ SVGs
const EmptyStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const FullStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="currentColor"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const HalfStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <defs>
      <linearGradient id="halfGradient">
        <stop offset="50%" stopColor="currentColor" />
        <stop offset="50%" stopColor="transparent" />
      </linearGradient>
    </defs>
    <path
      fill="url(#halfGradient)"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

function StarRating({ value = 0, onChange, active }) {
  const [hover, setHover] = useState(0);
  if (!active) return null;

  const displayed = hover || value;

  return (
    <div className="stars-container">
      {[1, 2, 3, 4, 5].map((n) => {
        let StarComponent = EmptyStar;
        if (displayed >= n) StarComponent = FullStar;
        else if (displayed >= n - 0.5) StarComponent = HalfStar;

        return (
          <div
            key={n}
            className="star-wrapper"
            onMouseMove={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              const x = e.clientX - rect.left;
              setHover(x < rect.width / 2 ? n - 0.5 : n);
            }}
            onMouseLeave={() => setHover(0)}
            onClick={() => onChange(hover || value)}
          >
            <StarComponent />
          </div>
        );
      })}
    </div>
  );
}

function Aventurera() {
  const [seen, setSeen] = useState(() =>
    JSON.parse(localStorage.getItem("seenMovies") || "{}")
  );
  const [ratings, setRatings] = useState(() =>
    JSON.parse(localStorage.getItem("movieRatings") || "{}")
  );

  useEffect(() => window.scrollTo(0, 0), []);

  const toggleSeen = (title) => {
    const s = { ...seen, [title]: !seen[title] };
    setSeen(s);
    localStorage.setItem("seenMovies", JSON.stringify(s));

    if (!s[title]) {
      const r = { ...ratings };
      delete r[title];
      setRatings(r);
      localStorage.setItem("movieRatings", JSON.stringify(r));
    }
  };

  const updateRating = (title, rating) => {
    const r = { ...ratings, [title]: rating };
    setRatings(r);
    localStorage.setItem("movieRatings", JSON.stringify(r));
  };

  return (
    <div className="personality-container">
      <h1>Aventurera</h1>
      <p>
        Lo que se dice una “story teller”, probablemente la persona con más
        historias por contar: viajes, aventuras, desdichas y alegrías, como si
        hubieras vivido varias vidas en una.
      </p>

      <div className="movies-grid">
        {movies.map((movie) => {
          const isSeen = seen[movie.title];
          const rating = ratings[movie.title] || 0;

          return (
            <div key={movie.title} className="movie-card">
              <div className="movie-card-inner">
                <div className="movie-card-front">
                  <img
                    src={movie.image}
                    alt={movie.title}
                    className={`movie-poster ${isSeen ? "dimmed" : ""}`}
                  />
                </div>

                <div className="movie-card-back">
                  <h3>{movie.title}</h3>
                  <p><strong>Director:</strong> {movie.director}</p>
                  <p><strong>Año:</strong> {movie.year}</p>
                  <p><strong>Reparto:</strong> {movie.cast}</p>
                  <p><strong>Sinopsis:</strong> {movie.synopsis}</p>

                  <button
                    className={`fancy-button ${isSeen ? "active" : ""}`}
                    onClick={() => toggleSeen(movie.title)}
                  >
                    {isSeen ? "✔ La viste" : "Marcar como vista"}
                  </button>

                  <StarRating
                    value={rating}
                    onChange={(v) => updateRating(movie.title, v)}
                    active={isSeen}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Aventurera;


